<!----复杂筛选框组件----->
<template>
  <div class="pagination">
    <span class="total">共 {{total}} 条 / {{pages}} 页</span>
    <span class="prev" :class="{'disabled':value==1}" @click="prePageHandle">&lt;</span>
    <span class="page" v-for="(page,index) in showPage" :key="index" :class="{'active':(changeStart + page-1)==value}"
      @click="changeShow(changeStart + page-1)">{{changeStart + page-1}}</span>
    <span class="next" :class="{'disabled':value==pages}" @click="nextPageHandle">&gt;</span>
    <span class="jump">
      前往
      <input type="text" v-model="val" @keydown.enter="jump" />
      页
    </span>
  </div>
</template>
<script>
export default {
  props: {
    listTotal: {
      type: Number,
      default: undefined,
    },
    pageSize: {
      type: Number,
      default: 1,
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showPage: 3,
      // name:"哈哈子"
      first: "首页",
      last: "尾页",
      prev: "上一页",
      next: "下一页",
      a: false,
      b: false,
      c: false,
      d: false,
      page: 1,
      // pageSize:10,
      total: 0, //总数
      list: [], //页数
      currentPage: 1, //当前页
      li: 1,
      value: 1,
      input: 0,
      pages: Math.ceil(this.listTotal / this.pageSize), //计算需要展示的总页数
      val: "", //记录输入框中的值
      // posPage:Math.floor(this.showPage/2)+1,//超过这个页码时，固定显示的位置
      posPage: 0,
      start: 1, //第一个页码的开始数字
    };
  },
  mounted() { },
  watch: {
    listTotal() {
      this.total = this.listTotal;
      this.pages = Math.ceil(this.listTotal / this.pageSize);
      if (this.pages < 3) {
        this.showPage = this.pages;
      } else {
        this.showPage = 3;
      }
      this.init();
    },
    pageIndex() {
      this.currentPage = this.pageIndex;
      this.value = this.pageIndex;
    },
  },
  created() { },
  computed: {
    changeStart() {
      //分页逻辑
      this.posPage = Math.floor(this.showPage / 2) + 1;
      if (this.pages <= this.showPage) {
        return (this.start = 1);
      } else {
        if (this.currentPage <= this.posPage) {
          return (this.start = 1);
        } else if (this.pages - this.currentPage <= this.posPage) {
          return (this.start = this.pages - this.showPage + 1);
        } else {
          return (this.start = this.currentPage - this.posPage + 1);
        }
      }
    },
  },
  methods: {
    changeShow(page) {
      this.currentPage = page;
      this.value = this.currentPage;
      this.$emit("currentPage", page);
    },
    jump() {
      if (this.val < 1) {
        this.val = 1;
      }
      if (this.val > this.pages) {
        this.val = this.pages;
      }
      this.val = Math.floor(this.val);
      this.$emit("currentPage", this.val);
      this.currentPage = this.val;
      this.val = "";
    },
    prePageHandle() {
      this.currentPage--;
      if (this.currentPage < 1) {
        this.currentPage = 1;
      }
      this.value = this.currentPage;
      this.$emit("currentPage", this.value);
    },
    nextPageHandle() {
      this.currentPage++;
      if (this.currentPage > this.pages) {
        this.currentPage = this.pages;
      }
      this.value = this.currentPage;
      this.$emit("currentPage", this.value);
    },
    //
    init() {
      this.list = [];
      this.li = Math.ceil(this.total / this.pageSize);
      if (this.li == 1) {
        this.a = true;
        this.b = true;
        this.c = true;
        this.d = true;
      }
      for (var i = 1; i <= this.li; i++) {
        this.list.push(i);
      }

      this.value = this.currentPage;
      this.input = this.currentPage;
      if (this.currentPage == 1) {
        this.a = true;
        this.b = true;
        this.c = false;
        this.d = false;
      } else if (this.currentPage == this.li) {
        this.a = false;
        this.b = false;
        this.c = true;
        this.d = true;
      } else {
        this.a = false;
        this.b = false;
        this.c = false;
        this.d = false;
      }
    },
    change(val) {
      this.input = parseInt(val.target.value);
    },
    just() {
      if (this.input <= this.li && this.input > 0 && this.input != NaN) {
        this.buttonPage(this.input);
      } else {
        this.value = "";
      }
    },
    First() {
      //
      this.buttonPage(1);
    },
    Last() {
      //
      this.buttonPage(this.li);
    },
    Prev() {
      //
      if (this.currentPage > 1) {
        this.buttonPage(this.currentPage - 1);
      }
    },
    Next() {
      //
      if (this.currentPage < this.li) {
        this.buttonPage(this.currentPage + 1);
      }
    },
    buttonPage(val) {
      if (val == 1) {
        this.a = true;
        this.b = true;
        this.c = false;
        this.d = false;
      } else if (val == this.li) {
        this.a = false;
        this.b = false;
        this.c = true;
        this.d = true;
      } else {
        this.a = false;
        this.b = false;
        this.c = false;
        this.d = false;
      }
      this.value = val;
      this.currentPage = val;
      this.input = val;

      this.$emit("currentPage", val);
      //ajax请求数据
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  margin: 100px auto 0;
  width: 80%;
}
.clear:after {
  content: "";
  display: block;
  clear: both;
}

.pagination {
  margin: 10px 0;
}

.pagination span {
  margin: 0 10px;
}

.pagination span.page,
.pagination span.prev,
.pagination span.next {
  cursor: pointer;
}

.pagination span.page:hover {
  color: #009966;
}

.pagination span.page.active {
  color: #009966;
  cursor: default;
}

.pagination span.prev.disabled,
.pagination span.next.disabled {
  color: #cccccc;
  cursor: not-allowed;
}

.pagination input[type="text"] {
  padding: 2px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  width: 60px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  outline: none;
  transition: 0.2s all;
}
.pagination input[type="text"]:focus {
  border-color: #009966;
}
</style>
